import React from 'react';

interface FormSectionProps {
  title: string;
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

const FormSection: React.FC<FormSectionProps> = ({ title, children, icon, className = "" }) => {
  return (
    <div className={`bg-card-bg-light sm:dark:bg-card-bg-dark py-6 px-4 sm:p-6 sm:shadow-xl sm:dark:shadow-2xl sm:rounded-md sm:border sm:border-2 ${className}`}>
      <div className="flex items-center mb-2">
        {icon && <span className="mr-3 text-primary">{icon}</span>}
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-600 dark:text-gray-100 step-description">{title}</h2>
      </div>
      {children}
    </div>
  );
};

export default FormSection;